// extracted by mini-css-extract-plugin
module.exports = {"starting":"StartingPage_starting__Xj_yr"};